// layouts/AppLayout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IoMenu } from "react-icons/io5";
import Sidebar from "../components/Sidebar";

const AppLayout = () => {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleMenu = () => {
    setSidebarOpen(!sidebarOpen);
    };


    return (
        <div className="layout-wrapper">
        
            {!sidebarOpen && (
                <div className="menu-icon" onClick={toggleMenu}>
                <IoMenu />
                </div>
            )}
            {sidebarOpen && <Sidebar setSidebarOpen={setSidebarOpen} />}
            
            <div>
                <Outlet />
            </div>

        </div>
    );

}

export default AppLayout;
